export const grabFullName = (internalUsers, moveTrackUser) => {
  if (internalUsers) {
    let fullName = internalUsers.find((u) => u.moveTrackUsername === moveTrackUser.toLowerCase())?.fullName;
    if (fullName && fullName.length !== 0) return fullName;
  }
  return moveTrackUser;
};